import { intl } from "LocaleWrapper";
import { Table, QuickFilterTypes } from "@cofano/cck";
import { TableId, useFrontendTable } from "components/table";
import { FormattedDate } from "utils/DateUtils";
import { IdtfGoodFragment } from "__generated__/view/products/graphql/product.fragments.generated";

interface ProductsIdtfTableProps {
	content: IdtfGoodFragment[];
	contentLoading: boolean;
	onRowClick: (row: IdtfGoodFragment) => void;
}

const ProductsIdtfTable = ({ content, contentLoading, onRowClick }: ProductsIdtfTableProps) => {

	const { tableProps } = useFrontendTable({
		id: TableId.ProductsIdf,
		content: content || [],
		onCustomFilter: (property) => {
			if (property === "idtfNumber") {
				return (field, value) => field.toString().includes(value);
			}
		},
	});

	return (
		<Table
			{...tableProps}
			contentLoading={contentLoading}
			onRowClick={row => onRowClick(row as IdtfGoodFragment)}
			columns={[ {
				id: "idtfNumber",
				title: intl.formatMessage({ id: "PRODUCT_IDTF_NUMBER" }),
				sortable: true,
				filterComponent: QuickFilterTypes.TEXT,
				width: 150,
			}, {
				id: "groupName",
				title: intl.formatMessage({ id: "PRODUCT_IDTF_GROUP" }),
				sortable: true,
				filterComponent: QuickFilterTypes.TEXT,
				width: 200,
			}, {
				id: "productName",
				title: intl.formatMessage({ id: "PRODUCT_IDTF_PRODUCT_NAME" }),
				sortable: true,
				filterComponent: QuickFilterTypes.TEXT,
				width: 300,
			}, {
				id: "importantRequirement",
				title: intl.formatMessage({ id: "PRODUCT_IDTF_IMPORTANT_REQUIREMENT" }),
				sortable: true,
				filterComponent: QuickFilterTypes.TEXT,
				width: 300,
			}, {
				id: "validFrom",
				title: intl.formatMessage({ id: "PRODUCT_IDTF_VALID_FROM" }),
				render: row => <FormattedDate date={row.validFrom} format="ll" />,
				sortable: true,
				filterComponent: QuickFilterTypes.DATE,
				width: 200,
			}, {
				id: "cleaningRegime",
				title: intl.formatMessage({ id: "PRODUCT_IDTF_CLEANING_REGIME" }),
				sortable: true,
				filterComponent: QuickFilterTypes.TEXT,
				width: 200,
			} ]} />
	);
};

export default ProductsIdtfTable;
